import { ColumnEditor } from 'LookupEditor/ColumnEditors/Base/ColumnEditor';

export class FlagCheckColumnEditor extends ColumnEditor {
    Show(): void {}

    ToString() {
        return 'FlagCheck';
    }
}
